module.exports = __webpack_public_path__ + "img/callCenterBanner.99023814.png";